import { get, post } from './common'
type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>

export namespace folder {
  export function add(data: PostData.Folder.AddModel) {
    return post<ApiBaseResult<{ folderId: number }>>('/folder/add', {}, { ...data })
  }

  export function update(data: PostData.Folder.UpdateModel) {
    return post<ApiBaseResult<unknown>>('/folder/update', {}, { ...data })
  }

  export function del(data: PostData.Folder.DeleteModel) {
    return post<ApiBaseResult<unknown>>('/folder/delete', {}, { ...data })
  }

  export function move(data: PostData.Folder.MoveModel) {
    return post<ApiBaseResult<unknown>>('/folder/move', {}, { ...data })
  }

  export function list(data: PostData.Folder.ListModel) {
    return get<ApiBaseResult<ServerData.Folder.ListData[]>>('/folder/search', {
      ...data,
    })
  }
}
